import moment from "moment"

import defaultProfilePicture from "../../../../assets/images/users/default-profile-picture.png"

// A club's logo lives in the club's own asset folder, by its id (the club's _id), where the web and SportyaOS read it too.
export const getClubProfileImage = club => {
  const image = club?.logoImage

  if (!image) return defaultProfilePicture
  if (/^https?:\/\//i.test(image)) return image

  return `${process.env.REACT_APP_API_URL}/assets/clubs/${club.id}/${image}`
}

export const getTermsAcceptance = (terms, systemVersion) => {
  const acceptedVersion = Number(terms?.acceptedVersion) || 0
  const currentVersion = Number(systemVersion) || 0
  const acceptedDate = terms?.dateAccepted
    ? moment(terms.dateAccepted).format("D MMM YYYY")
    : null

  if (currentVersion > 0 && acceptedVersion === currentVersion) {
    return {
      color: "success",
      label: acceptedDate ? `Accepted on ${acceptedDate}` : "Accepted",
    }
  }

  if (acceptedVersion > 0) {
    return {
      color: "danger",
      label: acceptedDate
        ? `Outdated · v${acceptedVersion}, ${acceptedDate}`
        : `Outdated · v${acceptedVersion}`,
    }
  }

  return { color: "danger", label: "Not accepted" }
}

export const toExternalUrl = value => {
  if (!value || typeof value !== "string") return null

  const trimmedValue = value.trim()
  if (!trimmedValue) return null
  if (/^https?:\/\//i.test(trimmedValue)) return trimmedValue
  if (/^[a-z][a-z\d+.-]*:/i.test(trimmedValue)) return null

  return `https://${trimmedValue}`
}
